var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading ball-pulse",attrs:{"id":"loading-pulse1"}},[_c('div'),_c('div'),_c('div'),_c('span',[_vm._v("加载中⋅⋅⋅")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }